import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "start-story-container" }
const _hoisted_2 = { class: "story-top-panel" }
const _hoisted_3 = { class: "panel-right" }
const _hoisted_4 = { class: "editor-layout" }
const _hoisted_5 = { class: "form-area" }
const _hoisted_6 = { class: "single-uploader-card" }
const _hoisted_7 = {
  key: 0,
  class: "img-preview-box"
}
const _hoisted_8 = { class: "hover-mask" }
const _hoisted_9 = {
  key: 1,
  class: "upload-trigger"
}
const _hoisted_10 = { class: "single-uploader-card" }
const _hoisted_11 = {
  key: 0,
  class: "img-preview-box"
}
const _hoisted_12 = { class: "hover-mask" }
const _hoisted_13 = {
  key: 1,
  class: "upload-trigger"
}
const _hoisted_14 = { class: "action-bar" }
const _hoisted_15 = { class: "preview-area" }
const _hoisted_16 = { class: "preview-header" }
const _hoisted_17 = { class: "mockup-phone" }
const _hoisted_18 = { class: "phone-screen" }
const _hoisted_19 = { class: "mock-nav" }
const _hoisted_20 = { class: "nav-title" }
const _hoisted_21 = { class: "screen-hero" }
const _hoisted_22 = {
  key: 1,
  class: "hero-placeholder"
}
const _hoisted_23 = {
  key: 1,
  class: "hero-placeholder"
}
const _hoisted_24 = { class: "screen-body" }
const _hoisted_25 = { class: "screen-title" }
const _hoisted_26 = { class: "screen-desc" }
const _hoisted_27 = { class: "screen-title" }
const _hoisted_28 = { class: "screen-desc" }
const _hoisted_29 = { class: "screen-footer" }
const _hoisted_30 = { class: "mock-next-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_segmented = _resolveComponent("el-segmented")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_PictureFilled = _resolveComponent("PictureFilled")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "zhanwei4" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "panel-left" }, [
        _createElementVNode("h2", { class: "section-title" }, "游戏剧情叙事编排"),
        _createElementVNode("span", { class: "section-tip" }, "编排玩家初入游戏的开篇序言与通关后的终局交代")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_segmented, {
          modelValue: _ctx.storyTab,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.storyTab) = $event)),
          options: _ctx.tabOptions,
          size: "large",
          class: "custom-story-segmented"
        }, null, 8, ["modelValue", "options"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_form, {
          model: _ctx.form,
          "label-width": "auto",
          "label-position": "top",
          ref: "ruleForm",
          "status-icon": "",
          class: "custom-form"
        }, {
          default: _withCtx(() => [
            (_ctx.storyTab === 'start')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_el_form_item, { label: "开场序言标题" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.startTitle,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.startTitle) = $event)),
                        placeholder: "例如：序章 · 迷雾初起",
                        maxlength: "40",
                        "show-word-limit": "",
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "序言背景故事正文" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.startContent,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.startContent) = $event)),
                        type: "textarea",
                        rows: 9,
                        placeholder: "请输入引人入胜的开篇故事、背景交代与启程引导...",
                        maxlength: "1000",
                        "show-word-limit": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "开场全屏/封面配图" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_el_upload, {
                          class: "uploader-box",
                          action: _ctx.UpdateApi,
                          "show-file-list": false,
                          "on-success": _ctx.handleAvatarSuccess,
                          "before-upload": _ctx.beforeAvatarUpload,
                          disabled: _ctx.allowUpload
                        }, {
                          default: _withCtx(() => [
                            (_ctx.form.startImg)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                  _createVNode(_component_el_image, {
                                    src: _ctx.form.startImg,
                                    class: "img-content",
                                    fit: "contain"
                                  }, null, 8, ["src"]),
                                  _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("span", {
                                      class: "del-btn",
                                      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.clearImage(1)), ["stop"])),
                                      title: "删除并重新上传"
                                    }, [
                                      _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Delete)
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                  _createVNode(_component_el_icon, { class: "icon" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Plus)
                                    ]),
                                    _: 1
                                  }),
                                  _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text" }, "点击上传开场插图", -1)),
                                  _cache[10] || (_cache[10] = _createElementVNode("span", { class: "sub-text" }, "支持 4:3 | 1:1 | 3:4 / 小于 5MB", -1))
                                ]))
                          ]),
                          _: 1
                        }, 8, ["action", "on-success", "before-upload", "disabled"])
                      ])
                    ]),
                    _: 1
                  })
                ], 64))
              : (_ctx.storyTab === 'end')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_el_form_item, { label: "通关结局标题" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.form.endTitle,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.endTitle) = $event)),
                          placeholder: "例如：终章 · 真相大白",
                          maxlength: "40",
                          "show-word-limit": "",
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "通关结局交代正文" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.form.endContent,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.endContent) = $event)),
                          type: "textarea",
                          rows: 9,
                          placeholder: "请输入揭开全部谜底后的剧情尾声、结局反转或致谢寄语...",
                          maxlength: "1000",
                          "show-word-limit": ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "复盘暗号" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.form.reviewCode,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.reviewCode) = $event)),
                          placeholder: "",
                          maxlength: "40",
                          "show-word-limit": "",
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "结局展示配图" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_el_upload, {
                            class: "uploader-box",
                            action: _ctx.UpdateApi,
                            "show-file-list": false,
                            "on-success": _ctx.handleAvatarSuccessEnd,
                            "before-upload": _ctx.beforeAvatarUpload,
                            disabled: _ctx.allowUploadEnd
                          }, {
                            default: _withCtx(() => [
                              (_ctx.form.endImg)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    _createVNode(_component_el_image, {
                                      src: _ctx.form.endImg,
                                      class: "img-content",
                                      fit: "contain"
                                    }, null, 8, ["src"]),
                                    _createElementVNode("div", _hoisted_12, [
                                      _createElementVNode("span", {
                                        class: "del-btn",
                                        onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.clearImage(2)), ["stop"])),
                                        title: "删除并重新上传"
                                      }, [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Delete)
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createVNode(_component_el_icon, { class: "icon" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Plus)
                                      ]),
                                      _: 1
                                    }),
                                    _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text" }, "点击上传结局插图", -1)),
                                    _cache[12] || (_cache[12] = _createElementVNode("span", { class: "sub-text" }, "支持 4:3 | 1:1 | 3:4 / 小于 5MB", -1))
                                  ]))
                            ]),
                            _: 1
                          }, 8, ["action", "on-success", "before-upload", "disabled"])
                        ])
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model"]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_el_button, {
            type: "primary",
            class: "save-btn",
            size: "large",
            loading: _ctx.saving,
            onClick: _ctx.handleSave
          }, {
            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
              _createTextVNode(" 保存全部剧情（开场与结局） ", -1)
            ]))]),
            _: 1
          }, 8, ["loading", "onClick"])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _cache[14] || (_cache[14] = _createElementVNode("span", { class: "badge-dot" }, null, -1)),
          _createElementVNode("span", null, "移动端" + _toDisplayString(_ctx.storyTab === "start" ? "启程序章" : "通关终局") + "呈现", 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "phone-top-bar" }, [
            _createElementVNode("div", { class: "notch" })
          ], -1)),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.storyTab === "start" ? "启程序章" : "终局揭晓"), 1)
            ]),
            _createElementVNode("div", _hoisted_21, [
              (_ctx.storyTab === 'start')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.form.startImg)
                      ? (_openBlock(), _createBlock(_component_el_image, {
                          key: 0,
                          src: _ctx.form.startImg,
                          alt: "序言配图",
                          fit: "contain",
                          class: "hero-img"
                        }, null, 8, ["src"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_PictureFilled)
                            ]),
                            _: 1
                          }),
                          _cache[15] || (_cache[15] = _createElementVNode("span", null, "暂无开场插图", -1))
                        ]))
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_ctx.form.endImg)
                      ? (_openBlock(), _createBlock(_component_el_image, {
                          key: 0,
                          src: _ctx.form.endImg,
                          alt: "结局配图",
                          class: "hero-img",
                          fit: "contain"
                        }, null, 8, ["src"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_PictureFilled)
                            ]),
                            _: 1
                          }),
                          _cache[16] || (_cache[16] = _createElementVNode("span", null, "暂无结局插图", -1))
                        ]))
                  ], 64))
            ]),
            _createElementVNode("div", _hoisted_24, [
              (_ctx.storyTab === 'start')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("h3", _hoisted_25, _toDisplayString(_ctx.form.startTitle || "序言标题占位"), 1),
                    _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.form.startContent ||
                    "开篇剧情、背景设定或启程引言将在此处完整展示，支持自动断行与上下平滑滑动..."), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("h3", _hoisted_27, _toDisplayString(_ctx.form.endTitle || "结局标题占位"), 1),
                    _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.form.endContent ||
                    "通关解谜交代、真相真相复盘或最终谢幕致辞将在此处完整展示..."), 1)
                  ], 64))
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("button", _hoisted_30, _toDisplayString(_ctx.storyTab === "start"
                    ? "开启冒险旅途"
                    : "完成探索 · 查看积分结算"), 1)
            ])
          ])
        ])
      ])
    ]),
    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "zhanwei4" }, null, -1))
  ]))
}